module.exports = __webpack_public_path__ + "static/img/ry_ruzhu.8aaa38fd.png";